<div class="container">
    <h2>New Item Template</h2>

        <mat-form-field appearance="outline">
            <mat-label>Item Type Name</mat-label>
            <input [(ngModel)]="name" matInput="matInput">
            <mat-hint *ngIf="nameWarning">Include a name!</mat-hint>
        </mat-form-field>

        <div class="submit">
            <button (click)="create()" mat-raised-button>Create</button>
        </div>
</div>
